<template>
  <div class="studentMessageHome">
    <div class="navBox">
      <ul class="navRight">
        <router-link
          
          v-for="(item, index) in navRight"
          :key="index"
          tag="li"
          :to="{
            path: infor.version == '2' ? item.path : item.path1,
          }"
        >
          {{ item.name }}
        </router-link>
      </ul>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "mineHome",
  components: {},
  data() {
    return {
      navRight: [
        {
          name: "成绩记录",
          idx: "0",
          path: "/consultant/minestudent/main/studentMessage/grade",
          path1: "/consultant/minestudent/main/studentMessage/grade",
          isShow: 2,
        },
        {
          name: "竞赛信息",
          idx: "1",
          path: "/consultant/minestudent/main/studentMessage/competition",
          path1: "/consultant/minestudent/main/studentMessage/competition",
          isShow: 2,
        },
        {
          name: "综合素质",
          idx: "2",
          path: "/consultant/minestudent/main/studentMessage/quality",
          path1: "/consultant/minestudent/main/studentMessage/quality",
          isShow: 2,
        },
        {
          name: "普查信息",
          idx: "3",
          path: "/consultant/minestudent/main/studentMessage/student",
          path1: "/consultant/minestudent/main/studentMessage/student",
          isShow: 2,
        },
        {
          name: "家长问卷",
          idx: "4",
          path: "/consultant/minestudent/main/studentMessage/parent",
          path1: "/consultant/minestudent/main/studentMessage/parent",
          isShow: 2,
        },
        {
          name: "生涯报告",
          idx: "5",
          path: "/consultant/minestudent/main/studentMessage/report",
          path1: "/consultant/minestudent/main/studentMessage/report",
          isShow: 2,
        },
        {
          name: "生涯解读",
          idx: "6",
          path: "/consultant/minestudent/main/studentMessage/reportInterpretation",
          path1:
            "/consultant/minestudent/main/studentMessage/reportInterpretation",
          isShow: 2,
        },
        // {
        //     name: '学习力报告',
        //     idx: '7',
        //     path: '/consultant/minestudent/main/studentMessage/reportLearning/learningReport2',
        //     path1: '/consultant/minestudent/main/studentMessage/reportLearning/learningReport3',
        //     isShow:2
        // },
        // {
        //     name: '学习力解读',
        //      idx: '8',
        //      path: '/consultant/minestudent/main/studentMessage/reportLearning/learningReportunscramble',
        //      path1: '/consultant/minestudent/main/studentMessage/reportLearning/learningReportunscramble3',
        //      isShow:2
        // },
      ],

      studentId: sessionStorage.getItem("myStudentStudentId"),
      infor:{},
    };
  },
  created() {
    this.getReportId();
  },
  methods: {
    getReportId() {
      this.$ajax
        .post(
          // this.G_acapi + this.ports.consultant.student.interView.getLearning,
          this.G_acapi + "/consultantNewStudent/getCareerReportIdByStudentId",
          {
            studentId: this.studentId,
          },
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          console.log(res, "返回版本");
          if (res.data.data.career.version === 2) {
            this.navRight = [
              {
                name: "成绩记录",
                idx: "0",
                path: "/consultant/minestudent/main/studentMessage/grade",
                path1: "/consultant/minestudent/main/studentMessage/grade",
                isShow: 2,
              },
              {
                name: "竞赛信息",
                idx: "1",
                path: "/consultant/minestudent/main/studentMessage/competition",
                path1:
                  "/consultant/minestudent/main/studentMessage/competition",
                isShow: 2,
              },
              {
                name: "综合素质",
                idx: "2",
                path: "/consultant/minestudent/main/studentMessage/quality",
                path1: "/consultant/minestudent/main/studentMessage/quality",
                isShow: 2,
              },
              {
                name: "普查信息",
                idx: "3",
                path: "/consultant/minestudent/main/studentMessage/student",
                path1: "/consultant/minestudent/main/studentMessage/student",
                isShow: 2,
              },
              {
                name: "家长问卷",
                idx: "4",
                path: "/consultant/minestudent/main/studentMessage/parent",
                path1: "/consultant/minestudent/main/studentMessage/parent",
                isShow: 2,
              },
              {
                name: "生涯报告",
                idx: "5",
                path: "/consultant/minestudent/main/studentMessage/report",
                path1: "/consultant/minestudent/main/studentMessage/report",
                isShow: 2,
              },
              {
                name: "生涯解读",
                idx: "6",
                path: "/consultant/minestudent/main/studentMessage/reportInterpretation",
                path1:
                  "/consultant/minestudent/main/studentMessage/reportInterpretation",
                isShow: 2,
              },
              {
                name: "学习力报告",
                idx: "7",
                path: "/consultant/minestudent/main/studentMessage/reportLearning/learningReport2",
                path1:
                  "/consultant/minestudent/main/studentMessage/reportLearning/learningReport3",
                isShow: 2,
              },
              {
                name: "学习力解读",
                idx: "8",
                path: "/consultant/minestudent/main/studentMessage/reportLearning/learningReportunscramble",
                path1:
                  "/consultant/minestudent/main/studentMessage/reportLearning/learningReportunscramble3",
                isShow: 2,
              },
            ];
            this.infor = res.data.data.learningCapacity;
            window.sessionStorage.setItem(
              "learningCapacityUser",
              this.infor.username
            );
            window.sessionStorage.setItem(
              "learningCapacitySchool",
              this.infor.agentHighSchoolId
            );
            
            // this.navRight[7].isShow = res.data.data.learningCapacity.version; // 获取版本
            // this.navRight[8].isShow = res.data.data.learningCapacity.version; // 获取版本            
          }
          // this.navRight[7].isShow=res.data.data.version;
          // this.navRight[8].isShow=res.data.data.version;
        });
    },
  },
};
</script>
<style scoped lang="less">
.studentMessageHome {
  .navBox {
    background-color: #fff;
    padding: 10px 15px 24px 15px;

    .navRight {
      padding: 0 25px;
      height: 55px;
      border-bottom: 1px solid rgba(217, 217, 217, 1);
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      li {
        box-sizing: border-box;
        height: 54px;
        line-height: 54px;
        font-size: 17px;
        font-weight: 500;
        cursor: pointer;
      }

      .router-link-active {
        border-bottom: 2px solid #3d90f6;
        color: #3d90f6;
      }
    }
  }
}
</style>